export function Setup() {
  return (
    <>
      <h3>Setup</h3>
      <li className="setup-list">
        <ul>Monitor1: Valkyrie 27″ Qhd 2k 200hz 1ms</ul>
        <ul>Monitor2: Samsung 22″ FHD 75Hz</ul>
        <ul>Case: Corsair 4000D Frame Black </ul>
        <ul>Cooling: SENTEY F80 ARGB 120MM 1800 RPM x7</ul>
        <ul>Rgb: HUB SENTEY ARGB PWM</ul>
        <ul>CPU: Ryzen 5 7600x 5.4Ghz</ul>
        <ul>Cooler CPU: Se-224-xts White Id-cooling </ul>
        <ul>GPU: RX6700 XT Sapphire Nitro+</ul>
        <ul>RAM: Kingston 32Gb DDR5 5200Mhz Fury Beast RGB X 1</ul>
        <ul>Motherboard: Msi Pro A620M-E</ul>
        <ul>Storage: 1TB SSD T-Force Vulcan Z 550MB/s </ul>
        <ul>PS: Cooler Master MWE V2 750W 80+ Gold Modular</ul>
        <ul>Keyboard: HyperX Alloy Origins 100% custom keycaps</ul>
        <ul>Mouse: VSG Aquila Air Black</ul>
        <ul>Headset: Redragon Zeus X Wireless</ul>
        <ul>VR: Oculus Quest 2 128gb</ul>
        <ul>Tracking: bno x2, bmi160 x4</ul>
        <ul>
          Laptop 1: Acer Aspire A325 Ryzen 7 7730u 32gb Ram 512gb. OS: W11
        </ul>
        <ul>
          Laptop 2: Intel Celeron 1.2ghz, 8gb Ram, 512gb SSD (🇦🇷). OS: Debian 13
        </ul>
      </li>
    </>
  );
}

export default Setup;
